import {twJoin} from 'tailwind-merge'

import {LazyImage, RichText, useSlideshowContext} from '../../'
import {preventNonMouseEvent} from '../utils'

interface SlideshowSlideDesktopProps {
  index: number
}

export const SlideshowSlideDesktop = ({index}: SlideshowSlideDesktopProps) => {
  const {items} = useSlideshowContext()
  const item = items[index]
  const hasText = item.richText.trim().length > 0

  return (
    <div className={'hidden size-full flex-col items-center justify-center md:flex'}>
      <div
        className={twJoin(
          'relative max-h-full',
          hasText && 'mr-[320px] ',
        )}
      >
        <LazyImage
          src={item.src}
          placeholderSrc={item.placeholderSrc}
          alt={item.alt}
          width={item.width}
          height={item.height}
          draggable={false}
          hasBackground={false}
          className={'size-full object-contain'}
        />
        {hasText ? (
          <div
            // disable carousel drag for non-mouse users on scrollable text container.
            onPointerDownCapture={preventNonMouseEvent}
            className={'sdox-scrollbar-inversed absolute inset-y-0 right-0 w-[320px] translate-x-full overflow-y-auto bg-scrim-primary/90 p-spacing-40 text-interactive-glyph-inversed-default'}
          >
            <RichText content={item.richText} />
          </div>
        ) : null}
      </div>
    </div>
  )
}
